// Hard-coded native-reporting layouts. Kept in sync with the backend chart
// registry (src/main/reporting/common/report-registry.ts). The layout is static
// metadata (which charts, in what order), so when native reporting is on we skip
// the GET /reporting/:reportKey/layout round-trip and render from here. Each
// chart's DATA still comes from POST /reporting/:reportKey/chart/:chartKey.

export interface ReportLayoutChart {
  key: string;
  title: string;
  visualisationType: string;
  width: number;
}

// Free-text filters a report's charts actually understand. The backend ignores
// any filter its charts don't wire up, so declaring them per report keeps the
// filter bar from showing controls that silently do nothing (e.g. "Inquiry Id"
// on the Booking report, whose cards key off the booking table).
export interface ReportTextFilter {
  key: string;
  placeholder: string;
}

export interface ReportLayout {
  reportKey: string;
  title: string;
  charts: ReportLayoutChart[];
  textFilters: ReportTextFilter[];
}

export const NATIVE_REPORT_LAYOUTS: { [reportKey: string]: ReportLayout } = {
  inquiry: {
    reportKey: 'inquiry',
    title: 'Inquiry Reports',
    textFilters: [
      { key: 'internalReferenceNumber', placeholder: 'Internal Ref. No.' },
      { key: 'inquiryReferenceNumber', placeholder: 'Inquiry Number' },
    ],
    charts: [
      { key: 'bid_level_details', title: 'Bid Level Details', visualisationType: 'table', width: 12 },
      { key: 'inquiry_level_details', title: 'Inquiry Level Details', visualisationType: 'table', width: 12 },
      { key: 'bids_detail_view', title: 'Bids Detail View', visualisationType: 'table', width: 12 },
      { key: 'avg_max_vs_min_cost', title: 'Average Max v/s Average Min Cost', visualisationType: 'table', width: 12 },
      { key: 'vendor_participation', title: 'Vendor Participation', visualisationType: 'table', width: 12 },
      { key: 'inquiry_lcl_fcl', title: 'Inquiry LCL FCL Reports', visualisationType: 'table', width: 12 },
      { key: 'inquiry_savings', title: 'Inquiry Savings Report', visualisationType: 'table', width: 12 },
    ],
  },
};
